import { render, staticRenderFns } from "./ViewPostPage.vue?vue&type=template&id=2e2e0b83&"
import script from "./ViewPostPage.vue?vue&type=script&lang=js&"
export * from "./ViewPostPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports